<template>
  <v-card>
    <v-card-text>
      <h3>Electrical Resistance</h3>
      <convert-box></convert-box>
    </v-card-text>
  </v-card>
</template>

<script>
import ConvertBox from '../components/ConvertBox'

export default {
  components: { ConvertBox },
  data() {
    return {
      unit: [
        {
          text: 'Abohm (abΩ)',
          val: 1
        },
        {
          text: 'Gigaohm (GΩ)',
          val: 1e-18
        },
        {
          text: 'Kiloohm (kΩ)',
          val: 1e-12
        },
        {
          text: 'Megaohm (MΩ)',
          val: 1e-15
        },
        {
          text: 'Microohm (µΩ)',
          val: 0.001
        },
        {
          text: 'Milliohm (mΩ)',
          val: 0.000001
        },
        {
          text: 'Nanoohm (nΩ)',
          val: 1
        },
        {
          text: 'Ohm (Ω)',
          val: 1e-9
        },
        {
          text: 'Volt per ampere (V/A)',
          val: 1e-9
        }
      ]
    }
  },
  created() {
    this.$store.dispatch('setUnit', this.unit)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// electrical-resistance.vue?0a583693